var map = {
	"../pages/adicionar-contato/adicionar-contato.module": [
		943,
		3
	],
	"../pages/imagem-ged/imagem-ged.module": [
		944,
		2
	],
	"../pages/login-web/login-web.module": [
		945,
		1
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 325;
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src lazy
// module id = 325
// module chunks = 4